import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withStorageServiceFeature } from '../store-features/storage-service.feature';
import {
  Address,
  ApprovalFormItem,
  IDifferentInvoiceRecipient,
  IERechnungsInfo,
  IOrderDetailsInfo,
  IProduktAuswahlDetails,
  IProduktSelektion,
  IVertragskonto,
  PredefinedTariffSelectionData,
  PreisIndikation,
  PriceSheet,
  Product,
  TariffChangeAvailabilities,
} from '@mwe/models';
import { ServiceStateEnum } from '@mwe/constants';
import { ConfirmationStatusState, withConfirmationStatusState } from '../store-features/confirmation-status-state.feature';
import { MemoryCacheItem } from '../cache/memory-cache.service';

const initialState = {
  address: undefined as Address,
  products: undefined as Product[],
  preselectedProduct: undefined as Product,
  directAddressSelection: undefined as boolean,
  isAddressSelectionVisible: undefined as boolean,

  tariffChangeAvailability: undefined as TariffChangeAvailabilities,
  productForSelection: undefined as Product[],
  predefinedTariffs: undefined as PredefinedTariffSelectionData[],
  // tariffChangeProducts: undefined as Product[],

  selectedTariff: undefined as IProduktSelektion,
  selectedPriceIndications: undefined as PreisIndikation[],
  priceSheets: undefined as PriceSheet[],
  isSelectedTariffSpot: undefined as boolean,
  userSelectedOffers: undefined as string[],
  hasUserSelectedOffer: undefined as boolean,
  productSelection: undefined as IProduktSelektion,
  productsAvailable: undefined as IProduktAuswahlDetails[],

  orderDetails: undefined as IOrderDetailsInfo[],
  eRechnungsInfo: undefined as IERechnungsInfo,
  invoiceData: undefined as IVertragskonto,
  differentInvoiceRecipient: undefined as IDifferentInvoiceRecipient,
  customerDataChangeData: undefined as { email: string; customerNumbers: string[] },
  immediateDelivery: undefined as boolean,

  emobilitySingleProductAvailable: undefined as boolean,
  allEmobilityProductsDisabled: undefined as boolean,
  orderSummaryProducts: undefined as Product[],

  orderSuccessfull: undefined as boolean,
  approvalItems: undefined as ApprovalFormItem[],

  state: undefined as ServiceStateEnum,
  tariffSelectionState: undefined as ServiceStateEnum,
  defaultTariff: undefined as string,
  preselectedTariffKey: undefined as string,
  initialProduct: undefined as IProduktSelektion,
};

type TariffChangeEmobilityStoreState = typeof initialState & ConfirmationStatusState;

const STORAGE_KEY = 'tariff-change-emobility';

export const TariffChangeEmobilityStore = signalStore(
  { providedIn: 'root' },
  withConfirmationStatusState({
    _memoryCacheItem: MemoryCacheItem.ClearingAccountDetails,
  }),
  withState(initialState),
  withStorageServiceFeature(STORAGE_KEY),
  withMethods(store => ({
    updateStoreState(partial: Partial<TariffChangeEmobilityStoreState>): void {
      patchState(store, partial);
    },
  })),
);
